<template>
  <div class="image-container relative flex size-full items-center justify-center">
    <img
      :src="`/event-poster/fallback.svg`"
      :alt="alt"
      class="max-h-full max-w-full object-contain transition ease-out group-hover:scale-105"
    />
  </div>
</template>

<script lang="ts" setup>
type PropType = {
  value?: string
  alt?: string
}

withDefaults(defineProps<PropType>(), { value: '', alt: '' })
</script>

<style scoped>
.image-container {
  container: image-container / inline-size;
}
</style>
